<script>
  import { onDestroy, createEventDispatcher, onMount } from "svelte";
  const dispatch = createEventDispatcher();
  function continueToForm() {
    dispatch("continue");
  }
  function cancel() {
    dispatch("cancel");
  }
</script>

<section class="section">
  <div class="content has-text-centered">
    <h2 class="has-text-centered has-text-success">
      Thank you, your form has successfully been submitted! If you would like to
      submit another record click the continue button below.
    </h2>
  </div>
  <br />
  <section id="addrecord-controls">
    <div style="text-align: center;">
      <button class="button is-success" on:click={continueToForm}>
        Continue
      </button>
      <button class="button is-danger is-light" on:click={cancel}>
        Cancel
      </button>
    </div>
  </section>
</section>
